// max days limit used to consider a notice account offer as overnight
export const MAX_NOTICE_PERIOD_DAYS_FAKE_OVERNIGHT = 4;
